module.exports = __webpack_public_path__ + "img/237.abf3d384.png";